<template>
    <form-item-wrapper :widget="widget" :formData="formData" ref="itemref">
        <a-textarea v-model:value="formData[widget.name]" :disabled="widget.options.disabled"
            :placeholder="widget.options.placeholder" :allowClear="widget.options.allowClear"
            :maxlength="widget.options.maxLength" :autoSize="widget.options.autoSize" :showCount="widget.options.showCount"
            @change="handleOnChange" @pressEnter="handleOnPressEnter">
        </a-textarea>
        <a-button :disabled="widget.options.disabled" @click="speak(widget.options.times)">语音输出</a-button>
    </form-item-wrapper>
</template>

<script setup>
import FormItemWrapper from "./form-item-wrapper.vue";
import { ref, toRefs } from 'vue';
import useEvent from "./useEvent";

const props = defineProps({
    widget: Object,
    formData: Object,
})
const { widget, formData } = toRefs(props)
const itemref = ref(null)

const parseNoToChinese = (code) => {
    var codeArray = ["零", "一", "二", "三", "四", "五", "六", "七", "八", "九"];
    if (code >= '0' && code <= '9') {
        return codeArray[parseInt(code)];
    }
    return code;
}
const translateText = (text) => {
    if (!text) {
        return "";
    }
    var len = text.length;
    var result = "";
    for (var idx = 0; idx < len; idx++) {
        result += " " + parseNoToChinese(text[idx]);
    }
    return result;
    // return text;
}
const speak = (times) => {
    var voiceText = translateText(formData.value[widget.value.name]);
    var speech = new SpeechSynthesisUtterance(voiceText);
    //语调
    speech.pitch = 1;
    //语速
    speech.rate = 1;
    // 设置说话的音量
    speech.volume = 10;
    // 设置播放语言
    speech.lang = 'zh-CN';
    if (!times) {
        times = 1;
    }
    if (times < 0) {
        times = 1;
    }
    window.speechSynthesis.speak(speech);
    times--;
    if (times > 0) {
        setTimeout(() => { this.speak(times) }, 3000);
    }
}

const {
    handleOnChange,
    handleOnPressEnter,
} = useEvent(widget.value, itemref, formData.value);
</script>